export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9209.e482c965.jpg";